export default "__VITE_ASSET__BQ19LGbs__"